<template>
  <div>
    <vs-card class="mt-6 mb-base">
      <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="route">

        <template slot="header">
          <div class="vx-col sm:w-1/2 w-full">
            <img :src="require('@/assets/images/icons/icon_folder_b.png')" style="position: absolute;margin-left: 20px;" />
            <h3 style="margin-left: 55px;">Staging A100PROD Table</h3>
          </div>

          <!-- ITEMS PER PAGE -->

          <div class="vx-col sm:w-1/4 w-full flex justify-between">
            <!--            <vs-button @click="activePrompt=true">Export</vs-button>-->
            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ route.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : route.length }} of {{ queriedItems }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="MESSAGEID">Message ID</vs-th>
          <vs-th sort-key="PRODID">Production ID</vs-th>
          <vs-th sort-key="WORKCENTERID">Work Center</vs-th>
          <vs-th sort-key="OPRID">Operation ID</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <!--            <router-link :to="'/staging/message/'+tr.MESSAGEID">-->
              <p class="product-name font-medium text-center">{{ tr.MESSAGEID }}</p>
              <!--            </router-link>-->
            </vs-td>
            <vs-td>
              <p class="product-name font-medium">{{ tr.PRODID }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium">{{ tr.WORKCENTERID }}</p>
              <p class="product-category">{{ tr.WORKCENTERNAME }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.OPRID }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
              <!--            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
            </vs-td>

          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      selected: [],
      route: [],
      itemsPerPage: 25,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.route.length
    }
  },
  methods: {
    fetchMessages () {
      this.$http.get('/api/staging/route')
        .then(items => {
          this.route = items.data.route
        })
    },
    addNewData () {
      this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    // deleteData (id) {
    //   this.$store.dispatch('dataList/removeItem', id).catch(err => {
    //     console.error(err)
    //   })
    // },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      // this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    moment (time) {
      return moment(time)
    }
  },
  mounted () {
    this.isMounted = true
  },
  created () {
    this.fetchMessages()
  }
}
</script>

<style>
.vs-card--content {
  padding: 0px;
}
.vs-table--search {
  padding-right: 20px !important;
}
</style>
